import 'core-js/stable'
import 'regenerator-runtime/runtime'

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import GlobalPlugins from './plugins/global'
// import { loadFonts } from './plugins/webfontloader'
import axios from 'axios'
import VueAxios from 'vue-axios'
import InfiniteLoading from 'vue-infinite-loading';
import PerfectScrollbar from 'vue2-perfect-scrollbar';
import { mapActions, mapMutations, mapGetters } from 'vuex';
import { VueReCaptcha } from 'vue-recaptcha-v3';
// import '@babel/polyfill'
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import '@mdi/font/css/materialdesignicons.css';
// import OneSignalVue from 'onesignal-vue';

// vue markdown 套件
import VMdEditor from '@kangc/v-md-editor';
import '@kangc/v-md-editor/lib/style/base-editor.css';
import VMdPreview from '@kangc/v-md-editor/lib/preview';
import '@kangc/v-md-editor/lib/style/preview.css';
import vuepressTheme from '@kangc/v-md-editor/lib/theme/vuepress.js';
import '@kangc/v-md-editor/lib/theme/style/vuepress.css';
import Prism from 'prismjs';
VMdEditor.use(vuepressTheme, { Prism });
import zhTW from '@kangc/v-md-editor/lib/lang/zh-TW';
// import MasonryWall from '@yeger/vue2-masonry-wall'
import { VueMasonryPlugin } from 'vue-masonry';

VMdEditor.lang.use('en-US', zhTW);
VMdPreview.use(vuepressTheme, {
  Prism,
});
Vue.use(VMdPreview);
Vue.use(VMdEditor);

// Google reCaptcha
Vue.use(VueReCaptcha, {
  siteKey: process.env.VUE_APP_RECAPTCHA_KEY,
  loaderOptions: {
    useRecaptchaNet: true, // 可選，如果 Google.com 被封鎖，使用 recaptcha.net
    autoHideBadge: true, // 可選，是否自動隱藏右下角的 reCAPTCHA 標誌（注意：若隱藏需自行顯示 reCAPTCHA 服務條款）
  },
});

Vue.use(VueAxios, axios);
Vue.use(router);
Vue.use(store);
Vue.use(vuetify);
Vue.use(GlobalPlugins);
// Vue.use(OneSignalVue);
Vue.use(PerfectScrollbar);
Vue.use(InfiniteLoading, {
  props: {
    spinner: 'circles',
  },
  system: {
    throttleLimit: 50,
  },
});
// Vue.use(MasonryWall);
Vue.use(VueMasonryPlugin);

if (process.env.NODE_ENV === 'production') {
  // eslint-disable-next-line no-multi-assign
  Vue.config.devtools = Vue.config.debug = Vue.config.productionTip = false;
} else {
  // eslint-disable-next-line no-multi-assign
  Vue.config.devtools = Vue.config.debug = Vue.config.productionTip = true;
}

// 全域function
Vue.prototype.$getAge = function(birthDay) {
  let today = new Date();
  let birthDate = new Date(birthDay);
  let age = today.getFullYear() - birthDate.getFullYear();
  let hasGetOld = (today.getMonth() + 1) * 30 + today.getDate() > (birthDate.getMonth() + 1) * 30 + birthDate.getDate();
  if(!hasGetOld) {
    if(today.getDate() !== birthDate.getDate()) {
      age = age - 1;
    }
  }
  return age;
};

Vue.mixin({
  data() {
    return {
      // BASE_URL: process.env.NODE_ENV === 'production' ? '/static/cms/' : '/',
      STATIC_URL: process.env.NODE_ENV === 'production' ? `${process.env.VUE_APP_GOOGLE_STORAGE_BUCKET}static/cms/` : '/',
      SERVER_STATIC_URL: process.env.VUE_APP_GOOGLE_STORAGE_BUCKET,

      SERVER_DOMAIN: process.env.NODE_ENV === 'production' ? '' : process.env.VUE_APP_BACKEND,
      WS_HEAD: process.env.npm_config_mode === 'test' ? 'ws' : 'wss',
      WS_DOMAIN: process.env.NODE_ENV === 'production' ? '//cancell.ai' : process.env.VUE_APP_BACKEND,
      NODE_DOMAIN: process.env.NODE_ENV === 'production' ? 'https://cancell.ai' : '//127.0.0.1:3000',
      OVERLAY_OPACITY: '0.8',
    }
  },
  methods: {
    showMsg(type, text) {
      this.updateMsgBox({
        active: true,
        type: type,
        content: text,
      });
    },

    avatarSrcLink(url) {
      if (url.includes('http:/') || url.includes('https:/')) {
        console.log('Line ThumbSrc');
        return url;
      }
      return `${this.SERVER_STATIC_URL}media/${url}`;
    },

    // async handleWpSendNotification(pushValue) {
    //   await axios.post('https://onesignal.com/api/v1/notifications', JSON.stringify({
    //     app_id: 'fab7d6fe-205f-4dab-b6de-9c56b2b8e2b7',
    //     contents: {en: pushValue.msg},
    //     headings: {en: pushValue.title},
    //     url: pushValue.url,
    //     filters: [
    //       {field: 'tag', key: 'type', relation: '=', value: pushValue.type},
    //       {field: 'tag', key: 'aid', relation: '=', value: pushValue.aid}, 
    //     ],
    //     // included_segments: ['Subscribed Users'],
    //     // include_external_user_ids: ['127'],
    //     // channel_for_external_user_ids: 'push',
    //   }), {
    //     headers: {
    //       // accept: 'application/json',
    //       Authorization: 'Basic MjMwNWVlOGMtMjFlYy00ZGQ3LWI4ZmEtNjFjZDc5N2JjY2Rk',
    //       'content-type': 'application/json'
    //     },
    //   });
    // },

    ...mapActions({
      $getNotify: 'global/getNotifyList'
    }),
    ...mapMutations({
      saveUserFastHistory: 'global/SAVE_FAST_HISTORY',
      resetUserFastHistory: 'global/RESET_FAST_HISTORY',
      updateUserProfile: 'global/UPDATE_USER_PROFILE',
      updateMsgBox: 'global/UPDATE_MESSAGE_BOX',
      updateTemplateImg: 'global/UPDATE_TEMPLATE_IMG',
      addChatGptDescription: 'global/ADD_CHATGPT_DESCRIPTION',
      removeChatGptDescription: 'global/REMOVE_CHATGPT_DESCRIPTION',
      resetChatGptDescription: 'global/RESET_CHATGPT_DESCRIPTION',
      clearAllNotify: 'global/SET_NOTIFY_DATA',
      setEporModulesQuesList: 'global/SET_EPRO_MODULES_QUES_LIST',
    }),
  },
  computed: {
    ...mapGetters({
      PERMISSION: 'global/PERMISSION',
      loginProfile: 'global/exportLoginUserProfile',
      loadUserHistory: 'global/exportFastHistoryList',
      loadChatGptDescription: 'global/exportChatGptDescription',
      msgBox: 'global/exportMessageBox',
      notificationList: 'global/notificationList',
      notificationCount: 'global/notificationCount',
    }),
  },
});

const vm = new Vue({
  store,
  router,
  vuetify,
  // created() {
  //   window.onbeforeunload = function(e) {
  //     localStorage.removeItem('cc-cms');
  //     // return "You have some unsaved changes";
  //   }
  // },
  // i18n,
  render: (h) => h(App),
  // beforeMount() {
  //   this.$OneSignal.init({
  //     appId: 'fab7d6fe-205f-4dab-b6de-9c56b2b8e2b7',
  //   });
  // },
}).$mount('#app');

(() => vm)();